export default "__VITE_ASSET__DIFfaEY9__"